import React from 'react';
import PropTypes from 'prop-types';

import { Button, ButtonGroup } from '@vds/buttons';
import { Body, Title } from '@vds/typography';
import { isMobile } from '../common/Helpers';
import { apiUrls } from '../../constants/apiUrl';
import { Margin } from '../common/styles';

const redirect5Ghome = () => {
  window.location.href = apiUrls().redirect5Ghome;
};

export const CartFaiCashOnlyNoBundleMsg = ({ message = '', defaultMsg = '' }) => (
  <Margin left="10px" right="10px">
    {message ? (
      <div dangerouslySetInnerHTML={{ __html: message }} />
    ) : (
      <Body size="large" color="#000000">
        {defaultMsg}
      </Body>
    )}

    <Margin top="10px" left="90px">
      <Button primary onClick={() => redirect5Ghome()}>
        Back to 5G Home
      </Button>
    </Margin>
  </Margin>
);

export const RoleFailMsg = ({ title = ' ', message = '', newCustBtnText = 'Order as a new customer', defaultMsg = '' }) => (
  <Margin left="10px" right="10px">
    {message ? (
      <>
        <Title size="XLarge" primitive="span">
          <span dangerouslySetInnerHTML={{ __html: title }} />
        </Title>
        <Body size="large">
          <span dangerouslySetInnerHTML={{ __html: message }} />
        </Body>
      </>
    ) : (
      <Title size="XLarge" color="#000000">
        {defaultMsg}
      </Title>
    )}

    <Margin top={isMobile() ? '250px' : '30px'}>
      <Button primary width={isMobile() ? '100%' : 'auto'} onClick={() => redirect5Ghome()}>
        {newCustBtnText}
      </Button>
    </Margin>
  </Margin>
);

export const CollectionsMsg = ({ collections_IND = '' }) => (
  <Margin left="10px" right="10px">
    {collections_IND ? (
      <div dangerouslySetInnerHTML={{ __html: collections_IND }} />
    ) : (
      <h4 className="normal">
        Please pay your past due amount before adding a device to your account. To process your order today, please make your payment online, then
        contact Customer Service at (800) 922-0204 for assistance with your order. Otherwise, you will be able to process your calling plan change
        request online after 24 hours of receipt of your payment.
        <h4 className="normal"> Please try again later.</h4>
      </h4>
    )}
    <Margin top="10px" left="90px">
      <Button primary onClick={() => redirect5Ghome()}>
        Back to 5G Home
      </Button>
    </Margin>
  </Margin>
);

export const FraudOrderMsg = ({ fraudContent = '', defaultMsg = '' }) => (
  <Margin left="10px" right="10px">
    {fraudContent ? (
      <div dangerouslySetInnerHTML={{ __html: fraudContent }} />
    ) : (
      <Margin top="10px" bottom="20px">
        <Title size="large" color="#000000">
          {defaultMsg}
        </Title>
      </Margin>
    )}

    <Margin top="10px" left="90px">
      <Button primary onClick={() => redirect5Ghome()}>
        Back to 5G Home
      </Button>
    </Margin>
  </Margin>
);

export const NotAccountOwnerMsg = ({ notAccountOwner = '' }) => (
  <Margin left="10px" right="10px">
    {notAccountOwner ? (
      <div dangerouslySetInnerHTML={{ __html: notAccountOwner }} />
    ) : (
      <div>
        <h1> Sorry, only Account Managers and Owners can order 5G Home.</h1>
        <Margin bottom="20px">
          <p>Our records show that you&apos;re an Account Member. Only Account Managers and Owners can place orders.</p> <br />{' '}
          <p>Ask the manager or owner of this account (usually a parent) to order for your role to Account Manager.</p>
        </Margin>
      </div>
    )}

    <Margin top="10px" left="90px">
      <Button primary onClick={() => redirect5Ghome()}>
        Back to 5G Home
      </Button>
    </Margin>
  </Margin>
);

export const CreditfailMsg = ({ accFailMessage = '', pastDueBalAmt = '' }) => {
  const redirectPayBalance = () => {
    window.location.href = apiUrls().redirectPayBalance;
  };

  return (
    <Margin left="10px" right="10px">
      <h1>You have a past due balance of ${pastDueBalAmt} on your account.</h1>
      {accFailMessage ? (
        <div dangerouslySetInnerHTML={{ __html: accFailMessage }} />
      ) : (
        <div className="marginBottom">
          Your past due balance must be paid first to continue with your transaction. Please click on Pay Balance at My Verizon to pay your past due
          balance. Once paid, you can continue with your transaction.
        </div>
      )}

      <Margin top="10px" left="40px">
        <ButtonGroup
          rowQuantity={{ desktop: 2, mobile: 2 }}
          data={[
            {
              children: 'Back to 5G Home',
              'data-testid': 'BackTo5GHome',
              size: 'large',
              use: 'primary',
              width: 'auto',
              onClick: () => redirect5Ghome(),
            },
            {
              children: 'Pay balance',
              'data-testid': 'PayBalance',
              size: 'large',
              use: 'secondary',
              width: 'primary',
              onClick: () => redirectPayBalance(),
            },
          ]}
          alignment="left"
        />
      </Margin>
    </Margin>
  );
};

CartFaiCashOnlyNoBundleMsg.propTypes = {
  message: PropTypes.string,
  defaultMsg: PropTypes.string,
};

RoleFailMsg.propTypes = {
  title: PropTypes.string,
  newCustBtnText: PropTypes.string,
  message: PropTypes.string,
  defaultMsg: PropTypes.string,
};

CreditfailMsg.propTypes = {
  accFailMessage: PropTypes.string,
  pastDueBalAmt: PropTypes.string,
};

CollectionsMsg.propTypes = {
  collections_IND: PropTypes.string,
};

FraudOrderMsg.propTypes = {
  fraudContent: PropTypes.string,
  defaultMsg: PropTypes.string,
};

NotAccountOwnerMsg.propTypes = {
  notAccountOwner: PropTypes.string,
};
